import React, {Component} from 'react';
import "./PersonNetwork.css"
import "./commonAnalysisStyle.css"
import * as d3 from "d3";
import * as _ from "underscore";
import $ from "jquery";

class PersonNetwork extends Component {

    force = undefined
    linkedByIndex = {};

    constructor(props) {
        super(props);
        this.state = {backgroundColor: '#000000', extraction: 'sentences'}
    }

    componentDidMount() {
        let linkedByIndex = this.linkedByIndex
        let textToSearch = "§¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢";
        let chart_svg = $("#person_network_d3view"), container_svg = chart_svg;
        let w = container_svg.width();
        let h = container_svg.height();
        this.force = d3.layout.force().size([w, h]).linkStrength(function (d) {
            return 1;
            if (d.value > 10) {
                return 1;
            } else if (d.value > 5) {
                return 0.6;
            } else if (d.value > 3) {
                return 0.4;
            } else {
                return 0.2;
            }

            // return (0.6);
        }).charge(function (d) {
            return (-5000);
        }).chargeDistance(1000).linkDistance(function (d) {

            let min = 200;

            return min;

        });

        let force = this.force

        function getRetinaRatio() {
            let devicePixelRatio = window.devicePixelRatio || 1
            let c = document.createElement('canvas').getContext('2d')
            let backingStoreRatio = [c.webkitBackingStorePixelRatio, c.mozBackingStorePixelRatio, c.msBackingStorePixelRatio, c.oBackingStorePixelRatio, c.backingStorePixelRatio, 1].reduce(function (a, b) {
                return a || b
            })

            return devicePixelRatio / backingStoreRatio
        }


        let ratio = getRetinaRatio();
        let scaledWidth = w * ratio;
        let scaledHeight = h * ratio;


        let nodes = force.nodes();
        let links = force.links();


        // while (links.length > 0) {
        //     links.pop();
        // }

        $("div#person_network_d3view").html("");

        // initial coords and scale
        // let translateX = 0;
        // let translateY = 0;
        let scaleXY = 0.09;
        let translateX = (w / 2) - 15;
        let translateY = (h / 2) - 40;
        let canvasNetId = "person_network_canvas_net";
        let canvas = d3.select("div#person_network_d3view").append("canvas").attr("id", canvasNetId).attr("width", scaledWidth).attr("height", scaledHeight).style("width", w + 'px').style("height", h + 'px').call(
            d3.behavior.zoom().scaleExtent([-5, 8]).translate([translateX, translateY]).scale(scaleXY, scaleXY).on("zoom", zoom)).on("wheel.zoom", null);
        let context = canvas.node().getContext("2d");
        context.scale(ratio, ratio)

        let container_canvas = document.getElementById(canvasNetId);

        let overElement = new Array();

        let scaleLabelThreshold = 0.6;

        let radius = 10;

        context.save();
        context.translate(translateX, translateY);
        context.scale(2, 2);
        context.restore();
        force.on("tick", tick).on("start", () => {
        }).start();

        function draw() {
            let selectedNodes = $("#person_network").data("selected_nodes");
            context.save();
            context.clearRect(0, 0, w, h);
            context.translate(translateX, translateY);
            context.scale(scaleXY, scaleXY);
            context.clearRect(0, 0, w, h);

            // draw links

            links.forEach(function (d) {
                //// link thickness ///
                let nsize = 1;
                for (let i = 0; i < d.value; i++) {
                    nsize += 1;
                    if (nsize >= 15) {
                        break;
                    }
                }

                context.save();
                context.beginPath();

                context.lineWidth = nsize;

                if ((_.contains(overElement, d.source.id + "") && _.contains(overElement, d.source.id + "")) && (d.source.id == overElement[0] || d.target.id == overElement[0]) && overElement.length > 0) {
                    context.strokeStyle = '#fff';
                } else if (overElement.length > 0) {
                    context.strokeStyle = 'rgba(170, 170, 170, 0.2)';

                } else if (overElement.length == 0) {
                    context.strokeStyle = '#c7c7c7';

                }
                context.moveTo(d.source.x, d.source.y);
                context.lineTo(d.target.x, d.target.y);
                context.stroke();
                context.closePath();
                context.restore();

            });

            // draw nodes

            nodes.forEach(function (d) {

                context.save();
                context.beginPath();
                // context.moveTo(d.x, d.y);
                radius = 10;
                if (d.name.toLowerCase().indexOf(textToSearch) > -1) {
                    radius = 40;
                    context.shadowColor = '#fff200';
                    context.shadowBlur = 60;
                }

                context.arc(d.x, d.y, radius, 0, 2 * Math.PI, false);
                if (_.contains(selectedNodes, d.name)) {
                    context.fillStyle = "#ff0000";
                } else if (scaleXY < 0.2) {
                    context.fillStyle = "#f66c40";
                } else {
                    context.fillStyle = "#f66c40";
                    if (_.contains(overElement, d.id + "") && overElement.length > 0) {
                        context.fillStyle = "#f66c40";
                    } else if (overElement.length > 0) {
                        context.fillStyle = convertHex("#f66c40", '0.2');
                    }
                }

                context.fill();
                context.lineWidth = 1;
                context.strokeStyle = '#fff';
                context.stroke();
                context.closePath();
                context.restore();

                if (scaleXY > scaleLabelThreshold) {
                    context.save();
                    context.beginPath();
                    context.font = '12px Helvetica';
                    let radius = 10;

                    if (d.name.toLowerCase().indexOf(textToSearch) > -1) {
                        radius = 30;
                        context.shadowColor = '#12c7fd';
                        context.shadowBlur = 40;
                    }
                    if (overElement.length == 0) {
                        context.fillText(d.name, d.x + radius + 2, d.y + 4);
                        context.fillStyle = "black";
                    } else if (_.contains(overElement, d.id + "") && overElement.length > 0) {
                        if (overElement[0] == d.id) {
                            context.fillText(d.name, d.x + radius + 2, d.y + 4);
                        } else {
                            context.fillText(d.name, d.x + radius + 2, d.y + 4);
                        }
                        context.fillStyle = "black";
                        // context.strokeText(d.name, d.x + 12, d.y + 4);
                    } else if (!_.contains(overElement, d.id + "") && overElement.length > 0) {
                        context.fillStyle = "rgba(0, 0, 0, 1)";
                    }
                    context.fill();
                    context.restore();
                }


            });


            context.restore();
        }

        function tick() {
            draw();
        }

        // ///////////////// mouse events ////////////////////////////

        let widget = this

        container_canvas.addEventListener('click', function (event) {

            // console.log(rect.left + " - "+rect.top);

            let x = (event.pageX - $('#' + canvasNetId).offset().left - translateX) / scaleXY, y = (event.pageY - $('#' + canvasNetId).offset().top - translateY) / scaleXY;

            //console.log(translateX + " - " + translateY);
            // Collision detection between clicked offset and element.

            nodes.forEach(function (d) {
                let node_size = 10;
                if (d.name.toLowerCase().indexOf(textToSearch) > -1) {
                    node_size = 30;
                }

                if (y > d.y - node_size && y < d.y + node_size && x > d.x - node_size && x < d.x + node_size) {
                    setTimeout(function () {
                        // ///// put click code here //////

                        let selectedNodes = $("#person_network").data("selected_nodes");

                        if (_.contains(selectedNodes, d.name)) {
                            selectedNodes.my_remove(d.name);
                            //   let tags = getTagsIdList(widget_id);
                            //   let range = get_widget_range(widget_id);
                            //  refreshCurrentFileList(widget_id, "loadFileListFromPersonEntities", range, null, JSON.stringify(selectedNodes), tags);

                            widget.props.callbackParent(selectedNodes);


                        } else {
                            selectedNodes.push(d.name);
                            widget.props.callbackParent(selectedNodes);
                            //  let tags = getTagsIdList(widget_id);
                            //  let range = get_widget_range(widget_id);
                            //  refreshCurrentFileList(widget_id, "loadFileListFromPersonEntities", range, null, JSON.stringify(selectedNodes), tags);
                        }
                        $("#person_network").data("selected_nodes", selectedNodes);

                        draw();

                        // console.log($("#" + widget_id).data("selected_nodes"));
                        // alert(d.name);

                        // //////
                    }, 0);
                }
            });
        }, false);

        container_canvas.addEventListener('mousemove', function (event) {

            overElement = new Array();
            // if (scaleXY > scaleLabelThreshold) {
            let x = (event.pageX - $('#' + canvasNetId).offset().left - translateX) / scaleXY, y = (event.pageY - $('#' + canvasNetId).offset().top - translateY) / scaleXY;
            nodes.forEach(function (d) {
                let node_size = 10;
                if (d.name.toLowerCase().indexOf(textToSearch) > -1) {
                    node_size = 30;
                }

                if (y > d.y - node_size && y < d.y + node_size && x > d.x - node_size && x < d.x + node_size) {
                    if (!_.contains(overElement, d.id + "")) {
                        overElement.push(d.id + "");
                        nodes.forEach(function (e) {
                            if (isConnected(e, d)) {
                                if (!_.contains(overElement, e.id + "")) {
                                    overElement.push(e.id + "");
                                }
                            }
                        });
                    }
                    return d;
                }
            });

            draw();


            // }
        }, false);

        // //////// end mouse events ==================

        // //// event action functions //////

        function zoom() {
            translateX = d3.event.translate[0];
            translateY = d3.event.translate[1];
            //scaleXY = d3.event.scale;
            draw();

        }


        function zoomIn() {
            // translateX = d3.event.translate[0];
            // translateY = d3.event.translate[1];
            scaleXY += scaleXY / 8;
            draw();

        }

        function zoomOut() {
            // translateX = d3.event.translate[0];
            // translateY = d3.event.translate[1];
            scaleXY -= scaleXY / 8;
            draw();

        }

        document.getElementById("person_zoom_in").addEventListener("click", (event) => {
            zoomIn()
        });

        document.getElementById("person_zoom_out").addEventListener("click", (event) => {
            zoomOut()
        });

        document.getElementById("personZoomInOut").addEventListener("wheel", (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (event.deltaY < 0) {
                zoomOut()
            }
            if (event.deltaY > 0) {
                zoomIn()
            }

        });


        function isConnected(a, b) {
            linkedByIndex = $("body").data("linkedByIndex");
            return linkedByIndex[a.id + "," + b.id] || linkedByIndex[b.id + "," + a.id] || a.id == b.id;
        }

        function convertHex(hex, opacity) {
            hex = hex.replace('#', '');
            let r = parseInt(hex.substring(0, 2), 16);
            let g = parseInt(hex.substring(2, 4), 16);
            let b = parseInt(hex.substring(4, 6), 16);

            let result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
            return result;
        }


        $('#PersonSearchBoxForm').submit(function (ev) {
            ev.preventDefault(); // to stop the form from submitting

            textToSearch = $('#person_search_box').val().toLowerCase();
            if (textToSearch.trim().length == 0) {
                textToSearch = "¢¢¢¢¢¢¢¢¢¢¢¢¢¢";
                //console.log(textToSearch);
            }

            draw();

            //widget.props.callbackParent( push($("#person_search_box").val()) );
        });


    }


    handleOptionChange = (changeEvent) => {
        this.setState({
            extraction: changeEvent.target.value
        }, () => {

        });

    }

    update(parameters) {

        let param = parameters

        this.setState({"fromTo": parameters.fromTo})
        let widget = this
        let elements = []
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "entitiesNetworkExtractor",
            data: param,
            async: true,
            dataType: "json",
            success: function (data) {
                //console.log(data);
                widget.updateNet(data)
            }
        });


    }


    updateNet(jsonNodes) {


        let linkedByIndex = this.linkedByIndex

        let force = this.force
        let nodes = force.nodes();
        let links = force.links();

        links.splice(0, links.length)


        Array.prototype.removeNode = function (needle) {
            for (let i in this) {
                if (this[i].id == needle) {
                    return this.splice(i, 1);
                }
            }
            return false;
        }


        Array.prototype.my_remove = function () {
            let what, a = arguments, L = a.length, ax;
            while (L && this.length) {
                what = a[--L];
                while ((ax = this.indexOf(what)) !== -1) {
                    this.splice(ax, 1);
                }
            }
            return this;
        };


        $("#person_network").data("selected_nodes", new Array());

        let mappingNodes = [];


        setTimeout(() => {
            step1(true);
            binder();

        }, 100)


        // //////// end event action functions //////////////////////

        function step1(withLink, ignoreUnlinkedNodes) {
            //console.log("adding nodes");
            let start = new Date().getTime();
            let nodesNumber = jsonNodes.nodes.length;
            let linksNumber = jsonNodes.links.length;

            if (ignoreUnlinkedNodes === undefined) {
                ignoreUnlinkedNodes = false;
            }

            let jsonNodesIdArray = [];
            for (let x = 0; x < jsonNodes.nodes.length; x++) {
                jsonNodesIdArray.push(jsonNodes.nodes[x].id);
            }
            let nodesIdArray = [];
            for (let x = 0; x < nodes.length; x++) {
                nodesIdArray.push(nodes[x].id);
            }

            for (let x = 0; x < jsonNodes.nodes.length; x++) {
                if (!ignoreUnlinkedNodes) {
                    if ($('#person_network_hideUnlinkedNodes').is(':checked')) {
                        if (!jsonNodes.nodes[x].linked) {
                            continue;
                        }
                    }
                }

                if ($.inArray(jsonNodes.nodes[x].id, nodesIdArray) < 0) {
                    nodes.push(jsonNodes.nodes[x]);
                }

                // nodeHash[jsonNodes.nodes[x].id] = x;
            }

            let tobePopped = [];

            for (let x = 0; x < nodes.length; x++) {
                if ($.inArray(nodes[x].id, jsonNodesIdArray) < 0) {
                    tobePopped.push(nodes[x].id);
                }
            }

            for (let x in tobePopped) {
                nodes.removeNode(tobePopped[x]);
            }

            mappingNodes = [];
            for (let x = 0; x < nodes.length; x++) {
                mappingNodes[nodes[x].id] = x;
            }


            let end = new Date().getTime();
            let time = end - start;
            //console.log("end adding nodes in:" + time);
            // restart();


            if (withLink) {
                setTimeout(() => {
                    step2updatelinks();
                }, 1)

            }

        }

        function popOutUnlinkedNodes() {
            let tobePopped = new Array();

            for (let x = 0; x < nodes.length; x++) {
                if (!nodes[x].linked) {
                    tobePopped.push(nodes[x].id);
                }
            }
            for (let x in tobePopped) {
                nodes.removeNode(tobePopped[x]);
            }
            force.start();
        }

        function step2updatelinks() {
            let start = new Date().getTime();
            //console.log("adding links");

            links.splice(0, links.length)
            // while (links.length > 0) {
            //     links.pop();
            // }

            for (let x = 0; x < nodes.length; x++) {
                nodes[x].linked = false;
            }

            //  let link_threshold = $('#person_network_thresholdOfCooccurenceControl').val();
            let link_threshold = 4

            for (let x = 0; x < jsonNodes.links.length; x++) {
                if (jsonNodes.links[x].source != undefined && jsonNodes.links[x].target != undefined) {
                    if (jsonNodes.links[x].size >= (link_threshold)) {
                        let s = mappingNodes[jsonNodes.links[x].source];
                        let t = mappingNodes[jsonNodes.links[x].target];
                        nodes[s].linked = true;
                        nodes[t].linked = true;
                        links.push({
                            source: nodes[s],
                            target: nodes[t],
                            "id": jsonNodes.links[x].id,
                            "value": jsonNodes.links[x].value
                        });
                    }
                }

            }

            popOutUnlinkedNodes();

            linkedByIndex = {};
            links.forEach(function (d) {
                linkedByIndex[d.source.id + "," + d.target.id] = 1;
            });
            //console.log(linkedByIndex);
            $("body").data("linkedByIndex", linkedByIndex);

            let end = new Date().getTime();
            let time = end - start;

            //console.log("end adding link in:" + time);
            // binder();

        }

        function step3clearLinks() {
            links.splice(0, links.length)
            // while (links.length > 0) {
            //     links.pop();
            // }
        }

        function binder() {


            $("#person_network .addLinksBtn").unbind("click");
            $("#person_network .addLinksBtn").bind("click", function () {
                force.stop();
                step2updatelinks();
                force.start();
            })

            /* $('#text_search').enterKey(function () {



             });
 */
            $("#person_network .removeLinksBtn").unbind("click");
            $("#person_network .removeLinksBtn").bind("click", function () {
                force.stop();
                step3clearLinks();
                force.start();
            });

            $("#person_network_thresholdOfCooccurenceControl").unbind("change");
            $("#person_network_thresholdOfCooccurenceControl").bind("change", function () {
                if ($('#person_network_hideUnlinkedNodes').is(':checked')) {
                    force.stop();
                    // step3clearLinks();
                    step1(true, true);
                    popOutUnlinkedNodes();
                    force.start();
                } else {
                    force.stop();
                    step2updatelinks();
                    force.start();
                }
            });

            $("#person_network_rangeOfCooccurenceControl").unbind("change");
            $("#person_network_rangeOfCooccurenceControl").bind("change", function () {

                let $this = $(this);
                let delay = 1000;

                clearTimeout($this.data('timer'));
                $this.data('timer', setTimeout(function () {
                    force.stop();
                    $this.removeData('timer');
                    //calculate_widget(widget_id);
                }, delay));
            })

            $('input[name=person_network_chooserExtractionMethod]').unbind("change");
            $('input[name=person_network_chooserExtractionMethod]').bind("change", function () {

                let typr = $('input[name=person_network_chooserExtractionMethod]:checked').val();
                if (typr == "sentences") {
                    $('#person_network_rangeOfCooccurenceControl').val('1');
                } else {
                    $('#person_network_rangeOfCooccurenceControl').val('10');
                }
                //calculate_widget(widget_id);
            })

            $('#person_network_animationControl').unbind("change");
            $('#person_network_animationControl').bind("change", function () {
                if ($(this).is(':checked')) {
                    force.start();
                } else {
                    force.stop();
                }
            })

            $('#person_network_hideUnlinkedNodes').unbind("change");
            $('#person_network_hideUnlinkedNodes').bind("change", function () {
                if ($(this).is(':checked')) {
                    popOutUnlinkedNodes();
                } else {
                    force.stop();
                    step1(false);
                    force.start();
                }
            })

        }

    }


    render() {
        return (
            <div  id='person_network' className="PersonNetworkWidgetStyle commonAnalysisFeatures">
                <center>
                    <div className="analisysTitle">Rete Persone</div>
                </center>
                <div id="personZoomInOut" className="mapboxgl-ctrl mapboxgl-ctrl-group" style={{marginTop: '300px', marginLeft: '10px', float: 'left', position: 'absolute'}}>
                    <button id="person_zoom_in" className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in" type="button" aria-label="Zoom In"/>
                    <button id="person_zoom_out" className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out" type="button" aria-label="Zoom Out"/>
                </div>
                <div style={{height: 'auto', bottom: '0px', top: '25px', right: '0px', width: '100%'}}>
                    <div style={{overflow: 'hidden'}}>
                        <center>
                            <div id="person_network_d3view" className="chart" style={{minWidth: '200px', height: '500x'}}>
                                <canvas id="person_network_canvas_net" width="1325" height="500" style={{width: '1325px', height: '500px'}}/>
                            </div>
                        </center>
                    </div>


                    <div style={{marginTop: '-100px', top: '0px', left: '0px', right: '0px', padding: '3px'}}>
                        <div id="lista_radio_person" className="radioList">
                            <input className="magic-radio" type="radio" name="radioPerson" id="pRadio1" value="sentences" checked={this.state.extraction === 'sentences'} onChange={this.handleOptionChange}/>
                            <label htmlFor="pRadio1">
                                Frasi
                            </label>
                            <input className="magic-radio" type="radio" name="radioPerson" id="pRadio2" value="tokens" checked={this.state.extraction === 'tokens'} onChange={this.handleOptionChange}/>
                            <label htmlFor="pRadio2">
                                Parole
                            </label>
                        </div>


                        {/*<button className="addLinksBtn btn btn-mini" title="show edges among nodes"><i className="fa fa-plus-circle" style={{marginRight: '5px'}}></i>Show Links</button>*/}
                        {/*<button className="removeLinksBtn btn btn-mini" title="hide edges among nodes" style={{marginLeft: '8px'}}><i className="fa fa-trash-o" style={{marginRight: '5px'}}></i>Hide Links</button>*/}
                        {/*<input title="select sentece as co-occurence window type" type="radio" name="person_network_chooserExtractionMethod" id="phrases" value="sentences" checked="checked" style={{display: 'inline', marginRight: '5px', marginLeft: '8px'}}/><label title="select sentece as co-occurence window type" for="sentences" style={{display: 'inline', marginRight: '5px'}}>Sentences</label>*/}
                        {/*<input title="select token as co-occurence window type" type="radio" name="person_network_chooserExtractionMethod" id="tokens" value="tokens" style={{display: 'inline', marginRight: '5px', marginLeft: '8px'}}/> <label title="select token as co-occurence window type" for="tokens" style={{display: 'inline', marginRight: '5px'}}>Tokens</label>*/}
                        {/*<label title="co-occurence window width" style={{display: 'inline', marginLeft: '12px', verticalAlign: 'middle'}}>Range</label><input title="co-occurence window width" id="person_network_rangeOfCooccurenceControl" title="minimal number of co-occurences between persons" id="person_network_thresholdOfCooccurenceControl" type="number" style={{display: 'inline', verticalAlign: 'middle', marginLeft: '5px', width: '40px'}} value="1" min="1" max="10"/>*/}
                        {/*<input title="stop/resume newtwork animation" id="person_network_animationControl" type="checkbox" name="checkMeOut" checked="checked" style={{marginLeft: '8px'}}/><label title="stop/resume newtwork animation" for="checkMeOut" style={{display: 'inline', verticalAlign: 'middle', marginLeft: '5px'}}>Animated</label>*/}
                        {/*<input id="person_network_hideUnlinkedNodes" type="checkbox" name="checkMeOutNodes" style={{marginLeft: '8px'}}/><label for="checkMeOutNodes" style={{display: 'inline', verticalAlign: 'middle', marginLeft: '5px'}}>Hide Unlinked Nodes</label>*/}
                        <form id="PersonSearchBoxForm" className="form-wrapper" style={{marginTop: '5px', marginBottom: '10px', marginLeft: '0px'}}>
                            <input id="person_search_box" type="text" placeholder="Cerca fra le persone..." style={{zIndex: '30000'}}/>
                            <button type="submit" style={{color: '#9d0cea', zIndex: '30000'}}>Cerca</button>
                        </form>
                    </div>


                    {/*<div id="search_panel" style={{bottom: '120px', left: '0px', right: '0px'}}>*/}
                    {/*<div style={{marginTop: '5px', marginLeft: '25px', fontSize: '14px'}}><b>Find:</b> <input id="text_search" type="text" value="" style={{marginLeft: '10px', color: '#000', width: '200px'}}/></div>*/}
                    {/*</div>*/}
                </div>

            </div>
        );
    }
}

export default PersonNetwork;


// WEBPACK FOOTER //
// ./src/components/PersonNetwork.jsx